import { DateTime } from "luxon";

export function uses24Hour(langCode: string) {
    return new Intl.DateTimeFormat(langCode, {
        hour: 'numeric'
    }).formatToParts(DateTime.now().toJSDate()).find(part => part.type === 'hour').value.length === 2;
}
